export const FETCH_PRODUCT_HIERARCHY = '@@productHierarchy/fetch-product-hierarchy';
export const FETCH_PRODUCT_HIERARCHY_SUCCESS = '@@productHierarchy/fetch-product-hierarchy-success';
export const FETCH_PRODUCT_HIERARCHY_FAILURE = '@@productHierarchy/fetch-product-hierarchy-failure';
